import Result from './Result'
import TableView from './TableView'

export { Result, TableView }
